import { NgOptimizedImage } from '@angular/common';
import { afterNextRender, Directive, ElementRef, inject, Renderer2 } from '@angular/core';


@Directive({
  selector: 'img[ngSrc][remove-fill-style]',
  standalone: true,
})
export class RemoveFillStyleDirective {
  private readonly optimized = inject(NgOptimizedImage, { self: true });
  private readonly renderer = inject(Renderer2);
  private readonly element = inject<ElementRef<HTMLImageElement>>(ElementRef).nativeElement;

  constructor() {
    afterNextRender({
      write: () => {
        if (this.optimized.fill) {
          this.renderer.removeStyle(this.element, 'position');
          this.renderer.removeStyle(this.element, 'width');
          this.renderer.removeStyle(this.element, 'height');
          this.renderer.removeStyle(this.element, 'inset');
        }
      },
    });
  }
}
